import { BaseErrorResponse } from 'types/errors'
import { useVerticalContext } from './context/useVerticalContext'
import { useAccountPreferenceMutation } from './mutations/useAccountPreferenceMutation'

export type UpdateIndustryPreferenceArgs = {
  value: boolean
  onSuccess?: () => void
  onError: (error: BaseErrorResponse) => void
}

export const useConfirmIndustryPreference = () => {
  const { setIsIndustryConfirmed } = useVerticalContext()
  const { mutate: putIndustryPreference, isPending: isUpdatingIndustryPreference } =
    useAccountPreferenceMutation<boolean>()

  const onUpdateIndustryPreference = ({
    value,
    onSuccess,
    onError,
  }: UpdateIndustryPreferenceArgs) => {
    putIndustryPreference(
      { preferenceKey: 'isIndustryVerticalConfirmed', value },
      {
        onSuccess: () => {
          setIsIndustryConfirmed(value)
          onSuccess?.()
        },
        onError,
      }
    )
  }

  return {
    isUpdatingIndustryPreference,
    onUpdateIndustryPreference,
  }
}
